// Messenger strings, merged into the S3 translations at boot (i18n.js: mergeLocaleMessage).
// The S3 file is not touched. Thai copy follows the Proship Messenger mockup.
// No literal braces in values: vue-i18n reads {x} as a parameter, so {{เลขพัสดุ}} is passed in as {track}.

const th = {
  menu_label: "Messenger",
  unavailable: "โหลดข้อมูล Messenger ไม่สำเร็จ",
  retry: "ลองอีกครั้ง",

  pages: {
    title: "เพจ Facebook ที่เชื่อมต่อ",
    summary: "เชื่อมต่ออยู่ {connected} จาก {total} เพจ · ใช้รับออเดอร์จากแชท ตอบแชท และส่งเลขพัสดุ",
    empty: "ยังไม่มีเพจที่เชื่อมต่อ เชื่อมต่อเพจ Facebook เพื่อส่งเลขพัสดุหาลูกค้าทาง Messenger อัตโนมัติ",
    connect: "เชื่อมต่อเพจ Facebook",
    reconnect: "เชื่อมต่อใหม่",
    disconnect: "ยกเลิกการเชื่อมต่อ",
    status_connected: "เชื่อมต่ออยู่",
    status_expired: "หลุดการเชื่อมต่อ",
    status_disconnected: "ยกเลิกการเชื่อมต่อแล้ว",
    page_id: "รหัสเพจ",
    shops: "ร้านค้าใน Proship",
    chat_orders: "ออเดอร์จากแชท",
    chat_orders_value: "{count} รายการ",
    connected_at: "เชื่อมต่อเมื่อ",
    needs_reauth: "ต้องเชื่อมต่อใหม่",
    needs_reauth_note: "เพจนี้ยังไม่ได้ให้สิทธิ์ส่งข้อความแจ้งเลขแทร็ค ส่งได้เฉพาะภายใน 24 ชั่วโมงหลังลูกค้าทัก กดเชื่อมต่อใหม่แล้วอนุญาตทุกข้อเพื่อส่งได้ตลอดเวลา",
    expired_note: "เพจนี้รับออเดอร์จากแชท ตอบแชท และส่งเลขพัสดุไม่ได้ จนกว่าจะเชื่อมต่อใหม่",
    disconnected_note: "ระบบหยุดส่งเลขพัสดุหาลูกค้าของเพจนี้ จนกว่าจะเชื่อมต่อใหม่",
    confirm_disconnect_title: "ยกเลิกการเชื่อมต่อเพจ {name}?",
    confirm_disconnect_text: "ระบบจะหยุดส่งเลขพัสดุหาลูกค้าของเพจนี้ เชื่อมต่อใหม่ได้ทุกเมื่อ",
    disconnected_toast: "ยกเลิกการเชื่อมต่อเพจ {name} แล้ว",
    connected_toast: "เชื่อมต่อเพจแล้ว {count} เพจ",
    connected_none: "ไม่ได้เชื่อมต่อเพจใหม่",
    error_cancelled: "คุณยกเลิกขั้นตอนเชื่อมต่อ Facebook ยังไม่ได้เพิ่มเพจใหม่",
    owned_by_other: "มี {count} เพจที่เชื่อมต่อกับบัญชี Proship อื่นอยู่แล้ว หากเป็นเพจของคุณ โปรดติดต่อทีมงาน",
    error_expired: "หมดเวลาเชื่อมต่อ Facebook โปรดลองอีกครั้ง",
    error_failed: "เชื่อมต่อเพจไม่สำเร็จ โปรดลองอีกครั้ง",
    claim_mismatch: "ลิงก์เชื่อมต่อนี้เป็นของบัญชี Proship อื่น โปรดกดเชื่อมต่อเพจจากบัญชีนี้",
    claim_expired: "ลิงก์เชื่อมต่อหมดอายุ โปรดลองอีกครั้ง",
    connect_failed: "เปิดหน้าเชื่อมต่อ Facebook ไม่สำเร็จ โปรดลองอีกครั้ง",
    action_failed: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
  },

  // ตั้งค่า › การจัดส่ง › เพจ Facebook (FbExamples, PageRow, ShopChoice, sheets, NudgePopup)
  ship: {
    card_title: "เพจ Facebook",
    show_examples: "ดูตัวอย่าง",
    hide_examples: "ซ่อนตัวอย่าง",
    connect: "เชื่อมต่อเพจ Facebook",
    connect_more: "เชื่อมต่อเพจเพิ่ม",
    reconnect: "เชื่อมต่อใหม่",
    status_connected: "เชื่อมต่อแล้ว",
    status_reconnect: "ต้องเชื่อมต่อใหม่",
    shop_line: "ร้าน: {name}",
    choose_shop: "เลือกร้าน",
    feat_tracking: "ข้อความแจ้งเลขพัสดุ",
    feat_ship: "เปิดบิลในแชท",
    pill_auto: "ส่งอัตโนมัติ",
    pill_off: "ปิดอยู่",
    pill_on: "เปิดอยู่",
    pill_pending: "รอเฟสอนุมัติ",
    pill_unsendable: "ส่งไม่ได้",
    rejected_note: "ข้อความใหม่ไม่ผ่าน",
    view_message: "ดูข้อความ",
    turn_on: "เปิด",
    turn_off: "ปิด",
    how_to: "ดูวิธีใช้",
    pitch: "แค่ยืนยันออเดอร์กับลูกค้าในแชท ออเดอร์ก็เข้า ProShip เอง",
    ship_on_toast: "เปิดบิลในแชท: เปิดแล้ว · เพจ {name}",
    ship_off_toast: "เปิดบิลในแชท: ปิดแล้ว · เพจ {name}",

    examples: {
      sample_page: "เพจของคุณ",
      track_title: "ข้อความแจ้งเลขพัสดุ",
      sample_bubble: "สวัสดี สมชาย คำสั่งซื้อของคุณได้รับการจัดส่งแล้ว!\n\nหมายเลขติดตามของคุณคือ PROS05972541F7\nเก็บเงินปลายทาง 1,290 บาท\n\nกดปุ่มด้านล่างเพื่อติดตามการจัดส่ง",
      track_button: "ติดตามการจัดส่ง",
      auto_bold: "ส่งให้เองทันทีที่ร้านได้เลขพัสดุ",
      benefit_1: "ลูกค้าไม่ต้องทักถามว่าของถึงไหน",
      benefit_2: "ลูกค้ารู้ว่าของมาแล้ว เตรียมเงินปลายทางไว้ ตีกลับน้อยลง",
      benefit_3: "ร้านไม่ต้องก๊อปเลขส่งเองทีละคน",
      ship_title: "เปิดบิลในแชท",
      chat_incoming: "สมชาย ใจดี 195/51 ถนนราชวิถี เขตดุสิต กรุงเทพ 10300 โทร 0634961593 เอากระถาง 2 ใบค่ะ",
      admin_label: "แอดมินตอบลูกค้า",
      order_mono: "#เปิดบิล\nสมชาย ใจดี\n195/51 ถนนราชวิถี เขตดุสิต กรุงเทพ 10300\n0634961593\nยอด 1290\nCOD: 1290\nกระถาง 2 ใบ",
      order_head: "ออเดอร์ใหม่จากแชท",
      order_status: "รอจัดส่ง",
      order_name: "สมชาย ใจดี",
      order_sub: "Kerry · เก็บเงินปลายทาง 1,290 บาท",
      order_note: "ลูกค้าเห็นข้อความยืนยัน ร้านได้ออเดอร์ใน ProShip",
      pitch_bold: "แค่ยืนยันออเดอร์กับลูกค้าในแชท ออเดอร์ก็เข้า ProShip เอง",
      pitch_sub: "ข้อความเดียว ลูกค้าได้อ่าน ร้านได้ออเดอร์ ไม่ต้องคีย์ซ้ำ ไม่ต้องก๊อปที่อยู่",
      pitch_how: "พิมพ์ #เปิดบิล ตามด้วยชื่อ ที่อยู่ เบอร์ ยอด COD",
      pitch_alt: "พิมพ์ /ship หรือ #จัดส่ง แทนก็ได้",
    },

    choice: {
      title: "เพจนี้ขายของร้านไหน?",
      sub: "เลือกได้ร้านเดียว ออเดอร์จากแชทของเพจนี้จะเข้าร้านนั้น",
      back: "กลับ",
      saved_toast: "เพจ {name} อยู่ในร้าน {shop} แล้ว",
      load_failed: "โหลดข้อมูลไม่สำเร็จ โปรดลองอีกครั้ง",
      save_failed: "บันทึกไม่สำเร็จ โปรดลองอีกครั้ง",
    },

    sheet: {
      title: "ข้อความแจ้งเลขพัสดุ",
      page_line: "เพจ {name}",
      live_now: "ลูกค้าเห็นข้อความนี้",
      new_not_live: "ข้อความใหม่ ยังไม่ส่งให้ลูกค้า",
      cod_label: "ลูกค้าเก็บเงินปลายทาง",
      paid_label: "ลูกค้าโอนแล้ว",
      saved_note: "บันทึกแล้วต้องรอเฟสตรวจก่อน ระหว่างนั้นยังส่งข้อความเดิมให้ลูกค้า",
      custom_label: "ปรับข้อความเอง",
      required: "ต้องมี",
      missing: "ต้องมี {track} และ {cod} อย่างละ 1 ที่",
      sameline: "{cod} ต้องอยู่คนละบรรทัดกับ {track}",
      edge: "ห้ามขึ้นต้นหรือลงท้ายข้อความด้วยช่อง {slot} (รวมตอนที่ตัดบรรทัดเก็บเงินปลายทางออก)",
      too_long: "ข้อความยาวเกิน {max} ตัวอักษร",
      name_once: "{name} ใส่ได้ครั้งเดียว",
      invalid_body: "ข้อความยังไม่ถูกต้อง ดูคำเตือนใต้ช่องข้อความ",
      unknown_token: "มีตัวแปรที่ระบบไม่รู้จัก ใช้ได้เฉพาะ {track} {cod} และ {name}",
      empty: "ใส่ข้อความก่อนบันทึก",
      save: "บันทึก",
      reset: "คืนค่าเดิม",
      check: "ตรวจสถานะ",
      pending_title: "รอเฟสอนุมัติ",
      pending_body: "ข้อความใหม่ยังไม่ส่ง จนกว่าเฟสจะอนุมัติ (ปกติไม่กี่นาที)",
      pending_live: "ตอนนี้ยังส่ง: {live}",
      live_default: "ข้อความมาตรฐาน",
      live_custom: "ข้อความเดิมของร้าน",
      pending_tag: "รอตรวจ",
      rejected_title: "เฟสไม่อนุมัติ",
      rejected_body: "ข้อความนี้ใช้ไม่ได้ แก้แล้วบันทึกใหม่ ตอนนี้ยังส่ง{live}",
      saved_custom: "ข้อความของร้าน",
      saved_standard: "ข้อความมาตรฐาน",
      unsaved: "ยังไม่บันทึก",
      test_button: "ส่งข้อความทดสอบถึงฉัน",
      test_phone: "เบอร์ที่คุณเคยพิมพ์ในแชทเพจนี้",
      test_cod: "ยอด COD สำหรับทดสอบ (ถ้ามี)",
      test_hint: "ส่งหาลูกค้าที่เคยให้เบอร์นี้ในแชทของเพจ",
      updating: "ระบบกำลังอัปเดต ลองใหม่ในอีกสักครู่",
      page_off: "เพจนี้หลุดการเชื่อมต่อ ระบบส่งข้อความไม่ได้จนกว่าจะเชื่อมต่อใหม่",
      close: "ปิด",
    },

    howto: {
      title: "เปิดบิลในแชท",
      line_1: "ตอนยืนยันออเดอร์กับลูกค้า พิมพ์ #เปิดบิล ขึ้นบรรทัดแรก",
      line_2: "บรรทัดถัดไป: ชื่อ ที่อยู่ เบอร์ ยอด (และ COD ถ้ามี)",
      line_3: "ส่งแล้วออเดอร์เข้า ProShip ใช้ขนส่งหลักของร้าน",
      got_it: "เข้าใจแล้ว",
    },

    nudge: {
      a_title: "ให้ลูกค้าได้เลขพัสดุทางแชทเอง",
      free: "ฟรี ช่วงทดลองใช้งาน",
      later: "ไว้ทีหลัง",
    },

    claim: {
      failed_toast: "มีเพจที่เชื่อมต่อไม่สำเร็จ โปรดลองอีกครั้ง",
      reason_no_shop: "เพจเชื่อมต่อแล้ว แต่ยังไม่มีร้านใน ProShip สร้างร้านก่อนแล้วกดเลือกร้าน",
      reason_other_seller_shop: "เพจนี้อยู่ในร้านของบัญชีอื่น ทัก LINE ทีมงาน",
      reason_not_seller: "ต้องเข้าด้วยบัญชีเจ้าของร้าน",
      reason_proship_failed: "เชื่อมร้านไม่สำเร็จ ลองอีกครั้ง",
    },
  },

  tracking: {
    template_title: "ข้อความแจ้งเลขพัสดุ",
    template_subtitle: "ส่งเลขพัสดุหาลูกค้าทาง Messenger อัตโนมัติ ตั้งค่าแยกแต่ละเพจ",
    template_preview: "ตัวอย่างข้อความ",
    cancel_preview: "ข้อความแจ้งยกเลิก",
    custom_label: "ปรับข้อความเอง",
    placeholder_hint: "ใส่ {token} ตรงที่ต้องการให้แสดงเลขพัสดุ ใส่ {name} ถ้าต้องการทักชื่อลูกค้า",
    placeholder_error: "ต้องมี {token} 1 ตำแหน่งเท่านั้น",
    edge_error: "ต้องมีข้อความทั้งก่อนและหลัง {token}",
    name_error: "ใส่ {name} ได้ไม่เกิน 1 ตำแหน่ง",
    unknown_token_error: "มีตัวแปรที่ระบบไม่รู้จัก ใช้ได้เฉพาะ {token} และ {name}",
    empty_error: "ใส่ข้อความก่อนบันทึก",
    too_long: "ข้อความต้องไม่เกิน {max} ตัวอักษร",
    save: "บันทึก",
    reset: "ใช้ข้อความเริ่มต้น",
    unsaved: "ยังไม่บันทึก",
    status_pending: "รอเฟสอนุมัติ",
    status_approved: "เฟสอนุมัติแล้ว",
    status_rejected: "เฟสไม่อนุมัติ",
    saved: "บันทึกแล้ว",
    saved_pending: "บันทึกแล้ว รอเฟสอนุมัติ ปกติใช้เวลาไม่กี่นาที",
    save_failed: "บันทึกไม่สำเร็จ ลองอีกครั้ง",
    meta_rejected: "เฟสไม่อนุมัติข้อความนี้ ระบบยังใช้ข้อความเดิม โปรดแก้แล้วบันทึกอีกครั้ง",
    approved_toast: "เฟสอนุมัติข้อความของเพจ {name} แล้ว",
    page_off: "เพจนี้หลุดการเชื่อมต่อ ระบบส่งข้อความไม่ได้จนกว่าจะเชื่อมต่อใหม่",
    button_text: "ติดตามการจัดส่ง",
    test_button: "ส่งข้อความทดสอบ",
    test_phone: "เบอร์โทรลูกค้า",
    test_hint: "ส่งหาลูกค้าที่เคยให้เบอร์นี้ในแชทของเพจ",
    test_sent: "ส่งข้อความทดสอบแล้ว",
    test_no_contact: "ไม่พบเบอร์นี้ในแชทของเพจ โปรดใช้เบอร์ที่ลูกค้าเคยให้ในแชท",
    test_invalid_phone: "เบอร์โทรไม่ถูกต้อง โปรดตรวจสอบอีกครั้ง",
    test_pending: "ข้อความยังรอเฟสอนุมัติ โปรดลองอีกครั้งในอีกไม่กี่นาที",
    test_failed: "ส่งข้อความทดสอบไม่สำเร็จ โปรดลองอีกครั้ง",
    test_rate_limited: "เพจนี้ส่งทดสอบครบ 5 ครั้งใน 1 ชั่วโมงแล้ว โปรดลองอีกครั้งภายหลัง",

    timeline_title: "ข้อความแจ้งเลขพัสดุ",
    sent_at: "ส่งเมื่อ",
    delivered: "ส่งถึงแล้ว",
    read: "ลูกค้าอ่านแล้ว",
    unread: "ลูกค้ายังไม่อ่าน",
    cancel_sent: "แจ้งยกเลิกแล้ว",
    sending: "กำลังส่ง",
    failed: "ส่งไม่สำเร็จ",
    failed_reason: "ส่งไม่สำเร็จ: {reason}",
    tracking_no: "เลขพัสดุ {no}",
    open_settings: "ตั้งค่าการจัดส่ง",

    column: "ข้อความ",
    badge_sent: "ส่งแล้ว",
    badge_read: "อ่านแล้ว",
    badge_pending: "กำลังส่ง",
    badge_failed: "ส่งไม่สำเร็จ",
    kind_tracking: "เลขพัสดุ",
    kind_cancel: "แจ้งยกเลิก",

    reason_blocked: "ลูกค้าไม่รับข้อความจากเพจนี้",
    reason_token: "เพจหลุดการเชื่อมต่อ โปรดเชื่อมต่อใหม่",
    reason_permission: "ไม่มีสิทธิ์ส่งข้อความจากเพจนี้ โปรดเชื่อมต่อใหม่",
    reason_rate: "เฟสจำกัดจำนวนการส่งชั่วคราว",
    reason_template: "ข้อความยังไม่ผ่านการอนุมัติจากเฟส",
    reason_unknown: "ไม่ทราบสาเหตุ",
    reason_generic: "ส่งไม่สำเร็จ",
  },
};

const en = {
  menu_label: "Messenger",
  unavailable: "Messenger is unavailable right now",
  retry: "Try again",

  pages: {
    title: "Connected Facebook Pages",
    summary: "{connected} of {total} Pages connected · used for chat orders, replies and tracking numbers",
    empty: "No Page connected yet. Connect a Facebook Page to send tracking numbers to customers on Messenger automatically",
    connect: "Connect Facebook Page",
    reconnect: "Reconnect",
    disconnect: "Disconnect",
    status_connected: "Connected",
    status_expired: "Connection lost",
    status_disconnected: "Disconnected",
    page_id: "Page ID",
    shops: "Proship shops",
    chat_orders: "Chat orders",
    chat_orders_value: "{count} orders",
    connected_at: "Connected",
    needs_reauth: "Reconnect needed",
    needs_reauth_note: "This Page has not granted the tracking-message permission, so messages only go out within 24 hours of the customer's last message. Press Reconnect and allow every item to send at any time.",
    expired_note: "This Page cannot receive chat orders, reply to chats or send tracking numbers until it is reconnected",
    disconnected_note: "No tracking messages are sent for this Page until it is reconnected",
    confirm_disconnect_title: "Disconnect {name}?",
    confirm_disconnect_text: "Tracking messages for this Page will stop. You can reconnect at any time",
    disconnected_toast: "{name} disconnected",
    connected_toast: "{count} Facebook Page(s) connected",
    connected_none: "No new Page connected",
    error_cancelled: "You cancelled the Facebook connection, no new Page was added",
    owned_by_other: "{count} Page(s) are already connected to another Proship account",
    error_expired: "The connect page timed out, please try again",
    error_failed: "Could not connect the Page, please try again",
    claim_mismatch: "This connect link belongs to another account",
    claim_expired: "The link has expired, please connect again",
    connect_failed: "Could not open Facebook connect, please try again",
    action_failed: "Something went wrong, please try again",
  },

  ship: {
    card_title: "Facebook Pages",
    show_examples: "Show examples",
    hide_examples: "Hide examples",
    connect: "Connect Facebook Page",
    connect_more: "Connect another Page",
    reconnect: "Reconnect",
    status_connected: "Connected",
    status_reconnect: "Needs reconnect",
    shop_line: "Shop: {name}",
    choose_shop: "Choose shop",
    feat_tracking: "Tracking number message",
    feat_ship: "Create orders in chat",
    pill_auto: "Auto-send",
    pill_off: "Off",
    pill_on: "On",
    pill_pending: "Waiting for Facebook",
    pill_unsendable: "Can't send",
    rejected_note: "New wording refused",
    view_message: "View message",
    turn_on: "On",
    turn_off: "Off",
    how_to: "How to use",
    pitch: "Just confirm the order with the customer in chat and it enters ProShip by itself",
    ship_on_toast: "Create orders in chat: on · {name}",
    ship_off_toast: "Create orders in chat: off · {name}",

    examples: {
      sample_page: "Your Page",
      track_title: "Tracking number message",
      sample_bubble: "Hi Somchai, your order has been shipped!\n\nYour tracking number is PROS05972541F7\nCash on delivery 1,290 THB\n\nTap the button below to track your parcel",
      track_button: "Track shipment",
      auto_bold: "Sent automatically as soon as the shop gets the tracking number",
      benefit_1: "Customers stop asking where their parcel is",
      benefit_2: "Customers know it is coming and prepare the COD cash, fewer returns",
      benefit_3: "The shop stops copying tracking numbers one by one",
      ship_title: "Create orders in chat",
      chat_incoming: "Somchai Jaidee 195/51 Ratchawithi Dusit Bangkok 10300 tel 0634961593, 2 plant pots please",
      admin_label: "Admin replies to the customer",
      order_mono: "#open-bill\nSomchai Jaidee\n195/51 Ratchawithi Dusit Bangkok 10300\n0634961593\nTotal 1290\nCOD: 1290\n2 plant pots",
      order_head: "New order from chat",
      order_status: "To ship",
      order_name: "Somchai Jaidee",
      order_sub: "Kerry · Cash on delivery 1,290 THB",
      order_note: "The customer sees a confirmation, the shop gets the order in ProShip",
      pitch_bold: "Just confirm the order with the customer in chat and it enters ProShip by itself",
      pitch_sub: "One message the customer reads and the shop gets the order, no retyping, no address copying",
      pitch_how: "Type #open-bill followed by name, address, phone, total and COD",
      pitch_alt: "You can type /ship or #ship instead",
    },

    choice: {
      title: "Which shop does this Page sell for?",
      sub: "Pick one shop. Chat orders from this Page will enter that shop",
      back: "Back",
      saved_toast: "{name} now belongs to {shop}",
      load_failed: "Could not load the data, please try again",
      save_failed: "Could not save, please try again",
    },

    sheet: {
      title: "Tracking number message",
      page_line: "Page {name}",
      live_now: "Customers see this message",
      new_not_live: "New wording, not sent to customers yet",
      cod_label: "Cash-on-delivery customer",
      paid_label: "Prepaid customer",
      saved_note: "After saving, Facebook reviews the wording first. Meanwhile the previous message is still sent",
      custom_label: "Custom wording",
      required: "Required",
      missing: "Use {track} and {cod} exactly once each",
      sameline: "{cod} must be on its own line, away from {track}",
      edge: "A {slot} placeholder cannot be the first or last thing in the message (also after the COD line is removed)",
      too_long: "The message is longer than {max} characters",
      name_once: "{name} can be used only once",
      invalid_body: "The message is not valid yet, see the warning under the box",
      unknown_token: "Unknown placeholder. Only {track} {cod} and {name} are allowed",
      empty: "Write a message before saving",
      save: "Save",
      reset: "Restore default",
      check: "Check status",
      pending_title: "Waiting for Facebook",
      pending_body: "The new wording is not sent until Facebook approves it (usually a few minutes)",
      pending_live: "Still sending: {live}",
      live_default: "Standard message",
      live_custom: "Previous shop wording",
      pending_tag: "In review",
      rejected_title: "Refused by Facebook",
      rejected_body: "This wording cannot be used. Fix it and save again. Still sending {live}",
      saved_custom: "Shop wording",
      saved_standard: "Standard message",
      unsaved: "Not saved",
      test_button: "Send me a test message",
      test_phone: "A number you typed in this Page's chat",
      test_cod: "COD amount for the test (optional)",
      test_hint: "Sent to the Messenger customer who used this phone number in the Page's chat",
      updating: "The system is updating, try again in a moment",
      page_off: "This Page lost its connection, messages cannot be sent until it is reconnected",
      close: "Close",
    },

    howto: {
      title: "Create orders in chat",
      line_1: "When confirming an order with the customer, type #open-bill on the first line",
      line_2: "Next lines: name, address, phone, total (and COD if any)",
      line_3: "Once sent, the order enters ProShip using the shop's main shipper",
      got_it: "Got it",
    },

    nudge: {
      a_title: "Let customers get the tracking number in chat by themselves",
      free: "Free during the trial",
      later: "Later",
    },

    claim: {
      failed_toast: "Some Pages failed to connect, please try again",
      reason_no_shop: "The Page is connected but you have no shop in ProShip yet. Create a shop, then tap Choose shop",
      reason_other_seller_shop: "This Page is in another account's shop. Contact the team on LINE",
      reason_not_seller: "Sign in with the shop owner account",
      reason_proship_failed: "Could not link the shop, try again",
    },
  },

  tracking: {
    template_title: "Tracking message",
    template_subtitle: "Send tracking numbers to customers on Messenger automatically, set per Page",
    template_preview: "Preview",
    cancel_preview: "Cancellation message",
    custom_label: "Custom wording",
    placeholder_hint: "Put {token} where the tracking number should appear. Put {name} to greet the customer by first name",
    placeholder_error: "Use {token} exactly once",
    edge_error: "{token} cannot be at the start or the end of the message",
    name_error: "Use {name} at most once",
    unknown_token_error: "Unknown placeholder. Only {token} and {name} are allowed",
    empty_error: "Write a message before saving",
    too_long: "The message is longer than {max} characters",
    save: "Save",
    reset: "Use default message",
    unsaved: "Not saved",
    status_pending: "Waiting for Facebook",
    status_approved: "Approved by Facebook",
    status_rejected: "Rejected by Facebook",
    saved: "Saved",
    saved_pending: "Saved, waiting for Facebook approval, usually a few minutes",
    save_failed: "Could not save, try again",
    meta_rejected: "Facebook refused this wording, the Page keeps its current message",
    approved_toast: "Facebook approved the message for {name}",
    page_off: "This Page lost its connection, messages cannot be sent until it is reconnected",
    button_text: "Track shipment",
    test_button: "Send test message",
    test_phone: "Customer phone number",
    test_hint: "Sent to the Messenger customer who used this phone number in the Page's chat",
    test_sent: "Test message sent",
    test_no_contact: "No customer with this phone number in the Page's chats",
    test_invalid_phone: "Invalid phone number",
    test_pending: "The message is waiting for Facebook approval, try the test again later",
    test_failed: "Could not send the test message",
    test_rate_limited: "Test messages are limited to 5 per hour per Page",

    timeline_title: "Tracking message",
    sent_at: "Sent",
    delivered: "Delivered",
    read: "Read by customer",
    unread: "Not read yet",
    cancel_sent: "Cancellation sent",
    sending: "Sending",
    failed: "Failed",
    failed_reason: "Failed: {reason}",
    tracking_no: "Tracking no. {no}",
    open_settings: "Open shipping settings",

    column: "Message",
    badge_sent: "Sent",
    badge_read: "Read",
    badge_pending: "Sending",
    badge_failed: "Failed",
    kind_tracking: "Tracking number",
    kind_cancel: "Cancellation",

    reason_blocked: "The customer does not accept messages from this Page",
    reason_token: "Page access expired",
    reason_permission: "The Page did not grant messaging permission",
    reason_rate: "Facebook is limiting sends for now",
    reason_template: "The message is not approved by Facebook yet",
    reason_unknown: "Unknown reason",
    reason_generic: "Failed to send",
  },
};

export default {
  th: { messenger: th },
  en: { messenger: en },
};
